import { inject, Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { map, switchMap } from 'rxjs';
// eslint-disable-next-line import-whitelist -- ok in this case
import { AbstractResource } from '../../../core/http/abstract-resource';
import { getAuthorizationPath } from '../authorization.service';
import { TokenManagementService } from '../token-management.service';

interface AccessToken {
  'https://accounts.sama.com/hubUserId': number;
}

interface AuthorizationResponse {
  action: string;
  allowed: boolean;
}

@Injectable({ providedIn: 'root' })
export class AuthorizationResourceService extends AbstractResource {
  private tokenManagementService = inject(TokenManagementService);

  checkPermissions$(resourceId: string, permissions: string[]) {
    return this.tokenManagementService.getToken$('access_token').pipe(
      switchMap((token) =>
        this.request$<AuthorizationResponse[]>('POST', getAuthorizationPath(), {
          body: this.buildPermissionRequest(resourceId, permissions, token),
          tokenScope: 'access_token',
          cache: true,
          customErrorMessage: 'Failed to check permissions.',
        }),
      ),
      map((responses) =>
        responses
          .filter((response) => response.allowed)
          .map((response) => response.action),
      ),
    );
  }

  private buildPermissionRequest(
    resourceId: string,
    permissions: string[],
    token: string,
  ) {
    const actorId =
      jwtDecode<AccessToken>(token)[
        'https://accounts.sama.com/hubUserId'
      ].toString();
    return permissions.map((permission) => ({
      actorType: 'user',
      actorId,
      resourceId,
      resourceType: 'project',
      action: permission,
      informational: true,
    }));
  }
}
